import { Path, Svg } from "react-native-svg";
import { getToken } from "@tamagui/core";
import { jsx } from "react/jsx-runtime";
const SvgSearch = ({ size = 24, color = "$contentPrimary", ...inProps }) => {
  const outProps = {};
  if (size && (outProps.width = size, outProps.height = size), color) {
    const colorToken = getToken(color, "color");
    outProps.color = colorToken;
  }
  const props = {
    viewBox: "0 0 24 24",
    ...inProps,
    ...outProps
  };
  return /* @__PURE__ */ jsx(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props, children: /* @__PURE__ */ jsx(
    Path,
    {
      fill: "#786E64",
      d: "M9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612Q6.778 3 9.5 3t4.613 1.888T16 9.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-5.6-5.6q-.75.6-1.725.95T9.5 16m0-2q1.875 0 3.188-1.312T14 9.5q0-1.876-1.312-3.187Q11.377 5.002 9.5 5T6.313 6.313 5 9.5t1.313 3.188T9.5 14"
    }
  ) });
};
var Search_default = SvgSearch;
export {
  Search_default as default
};
